import Vue from 'vue'
import { axios } from '@/utils/request';
import { getAction, postAction, deleteAction,putAction} from '@/api/api-manage';
import {UI_CACHE_DB_DICT_DATA} from '@/store/mutation-types';


// 重复校验
export const duplicateCheck = (params)=>getAction("/sys/duplicate/check",params);



// ------------------------------------------------------------------------------------------------------ 字典 start
/**  字典标签专用（通过code获取字典数组） */
export const ajaxGetDictItems = (code, params)=>getAction(`/sys/dict/getDictItems/${code}`,params);
export function getDictItemsFromCache(dictCode) {
    if (Vue.ls.get(UI_CACHE_DB_DICT_DATA) && Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode]) {
        let dictItems = Vue.ls.get(UI_CACHE_DB_DICT_DATA)[dictCode];
        //console.log("-----------getDictItemsFromCache----------dictCode="+dictCode+"---- dictItems=",dictItems)
        return dictItems;
    }
}
/**  添加字典 */
export const addDict = (params)=>postAction("/sys/dict/add",params);
/**  编辑字典 */
export const editDict = (params)=>putAction("/sys/dict/edit",params);
/**  字典树 */
export const treeList = (params)=>getAction("/sys/dict/treeList",params);
/**  添加字典项 */
export const addDictItem = (params)=>postAction("/sys/dictItem/add",params);
/**  编辑字典项 */
export const editDictItem = (params)=>putAction("/sys/dictItem/edit",params);
// ------------------------------------------------------------------------------------------------------ 字典 end




// ------------------------------------------------------------------------------------------------------ 角色 start
/**  添加角色 */
export const addRole = (params)=>postAction("/sys/role/add",params);
/**  编辑角色 */
export const editRole = (params)=>putAction("/sys/role/edit",params);
/**  检查角色代码 */
export const checkRoleCode = (params)=>getAction("/sys/role/checkRoleCode",params);
/**  获取所有的角色 */
export const getAllRole = (params)=>getAction("/sys/role/getAllRole",params);
// ------------------------------------------------------------------------------------------------------ 角色 end



//------------------------------------------------------------------------------------------------------- user start

/**  改变密码 */
export const changePassword = (params)=>putAction("/sys/user/changePassword",params);
/**  添加用户 */
export const addUser = (params)=>postAction("/sys/user/add",params);
/**  编辑用户 */
export const editUser = (params)=>putAction("/sys/user/edit",params);
/**  获取用户角色 */
export const queryUserRole = (params)=>getAction("/sys/user/queryUserRole",params);
/**  批量冻结 */
export const frozenBatchUser = (params)=>putAction("/sys/user/frozenBatch",params);
/**  获取用户列表 */
export const getUserList = (params)=>getAction("/sys/user/list",params);


/** sms */
export  const sms = (params)=>postAction("/web/user/sms",params);

/** 根据手机号码和验证码获取重置密码token */
export const getRetrievePasswordToken = (params)=>postAction("/web/user/getRetrievePasswordToken",params);

/**  重置密码 */
export const resetPassword = (params)=>postAction("/web/user/resetPassword",params);

/** 注册 */
export const register = (params)=>postAction("/web/user/register",params);

/** 绑定手机号码 */
export const bindingPhone =  (params)=>postAction("/web/user/weixinQrBindingPhone",params);

/** 检测当前token是否有效 */
export const checkToken = (params)=>postAction("/web/user/checkToken",params);

/** 根据token获取用户信息 */
export const  getUserByToken =  (params)=>postAction("/web/user/getUserByToken",params);

/** 登录 */
export function login(parameter) {
    return axios({
        url: '/web/user/login',
        method: 'post',
        data: parameter
    })
}

/** 登出 */
export function logout(token) {
    return axios({
        url: '/web/user/logout',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Access-Token':  token
        }
    })
}

/** 获取用户权限(后台手动写死菜单) */
export const getUserPermissions = (params)=>postAction("/web/user/getUserPermissions",params);

//------------------------------------------------------------------------------------------------------- user end



//------------------------------------------------------------------------------------------------------- permission start
export const getPermissionList = (params)=>getAction("/sys/permission/list",params);
/**  根据token获取用户权限 */
export const queryPermissionsByUser = (params)=>getAction("/sys/permission/getUserPermissionByToken",params);
/** 系统菜单列表(一级菜单) */
export const getSystemMenuList = (params)=>getAction("/sys/permission/getSystemMenuList",params);
/**  查询子菜单 */
export const getSystemSubmenu = (params)=>getAction("/sys/permission/getSystemSubmenu",params);
/**  查询子菜单(父ID（多个采用半角逗号分割）) */
export const getSystemSubmenuBatch = (params) => getAction('/sys/permission/getSystemSubmenuBatch', params);
/**  添加权限 */
export const addPermission= (params)=>postAction("/sys/permission/add",params);
/**  编辑权限 */
export const editPermission= (params)=>putAction("/sys/permission/edit",params);


/**  获取权限树(全部) */
export const queryTreeList = (params)=>getAction("/sys/permission/queryTreeList",params);
/**  获取权限树(全部)- for 角色 */
export const queryTreeListForRole = (params)=>getAction("/sys/role/queryTreeList",params);


/**  根据角色获取权限 */
export const queryRolePermission = (params)=>getAction("/sys/permission/queryRolePermission",params);
/**  保存角色权限 */
export const saveRolePermission = (params)=>postAction("/sys/permission/saveRolePermission",params);
//------------------------------------------------------------------------------------------------------- permission end





// ------------------------------------------------------------------------------------------------------ 部门 start
/** 根据ID删除部门 */
export const deleteByDepartId   = (params)=>deleteAction("/sys/depart/delete",params);
/**  加载部门树 */
export const queryDepartTreeList = (params)=>getAction("/sys/depart/queryTreeList",params);
/**  加载部门树 */
export const queryDepartTreeSync = (params)=>getAction("/sys/depart/queryDepartTreeSync",params);
/**  根据关键字搜索部门 */
export const searchDepartByKeywords   = (params)=>getAction("/sys/depart/searchBy",params);
/** 获取部门ID树 */
export const queryDepartIdTree = (params)=>getAction("/sys/depart/queryIdTree",params);



//二级部门管理
/**  获取部门权限 */
export const queryDepartPermission = (params)=>getAction("/sys/permission/queryDepartPermission",params);
/**  保存部门权限 */
export const saveDepartPermission = (params)=>postAction("/sys/permission/saveDepartPermission",params);
/**  获取我的部门树 */
export const queryMyDepartTreeList = (params)=>getAction("/sys/depart/queryMyDeptTreeList",params);

/**  根据部门查询权限树(部门角色的权限继承自部门权限) */
export const queryTreeListForDepartRole = (params)=>getAction("/sys/departPermission/queryTreeListForDeptRole",params);
/**  根据部门角色ID获取部门角色权限列表 */
export const queryDepartRolePermission = (params)=>getAction("/sys/departPermission/queryDeptRolePermission",params);
/**  保存部门角色授权 */
export const saveDepartRolePermission = (params)=>postAction("/sys/departPermission/saveDeptRolePermission",params);
// ------------------------------------------------------------------------------------------------------ 部门 end



// ------------------------------------------------------------------------------------------------------ 公告 start
/**  更新发布操作 */
export const releaseAnnouncement = (params)=>getAction("/sys/announcement/doReleaseData",params);
/**  更新撤销操作 */
export const reovkeAnnouncement = (params)=>getAction("/sys/announcement/doReovkeData",params);
// ------------------------------------------------------------------------------------------------------ 公告 end

































